import { useMutation, useQueryClient } from "@tanstack/react-query";

import { getAuth, isProfileAuth } from "~/providers/store/auth";
import { client } from "~/api/client";
import { productsKeys } from "~/api/products/keys";
import { DisplayError, DisplayErrorCodeEnum } from "~/utils/display-error";

export function useSuppliersGenerateColors() {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: async ({ hasProductColors }: { hasProductColors: boolean }) => {
      const auth = getAuth();
      if (!isProfileAuth(auth)) {
        throw new DisplayError(DisplayErrorCodeEnum.PROFILE_NOT_SELECTED);
      }

      if (hasProductColors) {
        const res = await client.v1.pos.suppliers.colors({
          body: {
            partnerId: auth.partnerId,
            schoolId: auth.schoolId,
            moduleId: auth.moduleId
          }
        });

        if (res.status === 204) {
          return;
        }

        throw res;
      }
    },
    onSuccess: async () => {
      await queryClient.invalidateQueries({
        queryKey: productsKeys.lists()
      });
    }
  });
}
